import React from "react";
import { useDispatch } from "react-redux";
import {
  setSearching,
  searchByMood,
  setSearchValue
} from "store/actions/search";
import { MOODS_TYPES } from "./types";
import { useTranslation } from "react-i18next";
import { Mood, Container } from './styles'
import { GAHandler } from "utils/GA";

const Moods = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const onSelectMood = (mood) => {
    const type = t(`mood-${mood.type}`);
    dispatch(setSearching());
    dispatch(searchByMood({ id: mood.category, contentType: "all" }));
    dispatch(setSearchValue(type));
    GAHandler(`ui_mood_${mood.type.toLowerCase()}`);
  };

  return (
    <Container>
      {MOODS_TYPES.map((mood) => (
        <Mood key={mood.type} onClick={() => onSelectMood(mood)}>
          <img
            src={mood.cover}
            alt={`${mood.type} mood`}
          />
        </Mood>
      ))}
    </Container>
  );
};

export default Moods;
